import SideBarWithMenu from './components/sidebar/SideBarWithMenu';
import './App.scss';
import './styles/global.scss';
import { Route, Switch, useHistory } from 'react-router-dom';
import Settings from './components/settings/Settings';
import Home from './components/home/Home';
import Invoices from './components/invoices/Invoices';
import InvoicesHome from './components/invoices/InvoicesHome';
import InvoiceDetails from './components/invoices/InvoiceDetails/InvoiceDetails';
import MasterData from './components/contactTabs/MasterData';
import ContactScreenWithTabs from './components/contactTabs/ContactScreenWithTabs';
import LlAdmin from './components/lladmin/lladmin';
import { useDispatch } from 'react-redux';
import AccessMgmt from './components/accessMgmt/AccessMgmt';
import ScanRoot from './components/scan/scanroot';
import { Toaster } from 'react-hot-toast';
//import { ToastProvider, useToasts } from 'react-toast-notifications';
//import { ToastContainer } from "react-toastify";
import NewCreditMemoScreen from './components/invoices/CreditMemos/NewCreditMemoScreen';
import Reports, { OldReports, NewReports } from './components/reports/Reports';
// import { useEffect, useState } from 'react';
import ReportDesigner from './report-designer';
import ReportViewer from './report-viewer';
import AddAccessManagementScreen from './components/accessMgmt/addScreen/addScreen';
// import UserService from './services/UserService';

function App() {
    // const dispatch = useDispatch();
    // const history = useHistory();

    // const [token, setToken] = useState('');

    // useEffect(() => {
    //     // perform side effect
    //     console.log(UserService.getUsername());
    //     // if(UserService.getUsername()){
    //     //     history.push("/company-selection")
    //     // }
    // }, [UserService.getUsername()]);

    return (
        <div className="App">
            {/* <ToastProvider> */}
            {/* <ToastContainer /> */}
            <Toaster />
            <Switch>
                <SideBarWithMenu>
                    <Route exact path="/settings" component={Settings} />
                    <Route exact path="/invoices" component={InvoicesHome} />
                    <Route exact path="/LLAdmin" component={LlAdmin} />
                    <Route
                        exact
                        path="/invoices/:invoicetype"
                        component={Invoices}
                    />
                    <Route
                        exact
                        path="/invoices/:invoicetype/newcreditmemo"
                        component={NewCreditMemoScreen}
                    />
                    <Route
                        exact
                        path="/invoices/:invoicetype/Details"
                        component={InvoiceDetails}
                    />
                    <Route exact path="/scan" component={ScanRoot} />
                    <Route exact path="/Home" component={Home} />
                    <Route exact path="/reports" component={NewReports} />
                    <Route exact path="/masterdata" component={MasterData} />
                    <Route
                        exact
                        path="/accessManagement"
                        component={AccessMgmt}
                    />
                    <Route
                        exact
                        path="/accessManagement/add"
                        component={AddAccessManagementScreen}
                    />

                    <Route exact path="/oldReports" component={OldReports} />
                    <Route
                        exact
                        path="/masterData/:masterType"
                        component={ContactScreenWithTabs}
                    />
                    <Route exact path="/" component={Home} />
                    <Route
                        path="/report-designer"
                        component={ReportDesigner}
                        exact
                    ></Route>
                    <Route
                        path="/report-viewer"
                        component={ReportViewer}
                        exact
                    ></Route>
                </SideBarWithMenu>
            </Switch>

            {/* </ToastProvider> */}
        </div>
    );
}

export default App;
